module.exports = __webpack_public_path__ + "img/profile.7bd967c5.svg";